<template>
  <div class="shapeHome">
    <div class="angle" :class="{red:color=='red',sye:color=='sye',qye:color=='qye'}"></div>
    <span class="angletext">{{num}}</span>
  </div>
</template>

<script>
  export default {
    name: 'shape',
    data () {
      return {
      }
    },
    props:["color","num"],
    mounted(){
    }
  }
</script>

<style scoped>
  .shapeHome{
    position: relative;
    display: inline-block;
  }
  .angle{
    display:block;
    width:0;
    height:0;
    border-width:0 1.5rem 1.5rem;
    border-style:solid;
    border-color:transparent transparent #fc0;
    transform: rotate(315deg);
  }
  .red{
    border-color: transparent transparent #de0112;
  }
  .qye{
    border-color: transparent transparent #FFA304;
  }
  .sye{
    border-color: transparent transparent #FFE301;
  }
  .angletext{
    transform: rotate(315deg);
    display: inline-block;
    color: #ffffff;
    position: absolute;
    top: 0.3rem;
    left: 1.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/shape.vue